import { PieChart, Pie, Cell, ResponsiveContainer } from "recharts";
import PropTypes from "prop-types";

export function SemiCircleGauge({
  value,
  total,
  label,
  color = "#34d399",
  trackColor = "rgba(45,212,191,0.12)",
  height = 220,
}) {
  const pct = total > 0 ? Math.round((value / total) * 100) : 0;
  const remainder = total - value;
  const data = [
    { name: label || "Active", value },
    { name: "Rest", value: remainder > 0 ? remainder : 0 },
  ];

  return (
    <ResponsiveContainer width="100%" height={height}>
      <PieChart>
        <Pie
          data={data}
          cx="50%"
          cy="62%"
          startAngle={180}
          endAngle={0}
          innerRadius="42%"
          outerRadius="92%"
          paddingAngle={0}
          dataKey="value"
          stroke="none"
          animationDuration={1000}
          animationEasing="ease-out"
        >
          <Cell fill={color} />
          <Cell fill={trackColor} />
        </Pie>
        <text
          x="50%"
          y="58%"
          textAnchor="middle"
          dominantBaseline="middle"
          style={{ fontSize: "1.5rem", fontWeight: 800, fill: color }}
        >
          {pct}%
        </text>
      </PieChart>
    </ResponsiveContainer>
  );
}

SemiCircleGauge.propTypes = {
  value: PropTypes.number.isRequired,
  total: PropTypes.number.isRequired,
  label: PropTypes.string,
  color: PropTypes.string,
  trackColor: PropTypes.string,
  height: PropTypes.number,
};

export default SemiCircleGauge;
